const refreshActionType = {
    SET_REFRESH:  'SET_REFRESH'
}

export default refreshActionType;
